/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * CustomModal
 *
 * @file  CustomModal.jsx
 * @author Gladson Samuel S
 * @since 1.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, IconButton } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import withCustomModalStyles from './Styles/CustomModalStyles';

const CustomModal = ({
  open,
  onClose,
  children,
  classes
}) => {
  const renderCloseButton = () => {
    if (!onClose) return null;

    return (
      <IconButton
        className={classes.closeButton}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{
        paper: classes.paper,
        root: classes.root
      }}
    >
      {renderCloseButton()}
      <div className={classes.content}>
        {children}
      </div>
    </Dialog>
  );
};

CustomModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  children: PropTypes.node,
  classes: PropTypes.object
};

CustomModal.defaultProps = {
  onClose: () => {},
  children: null,
  classes: {}
};

export default withCustomModalStyles(CustomModal);
